import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import { handleChangeFile } from "../../../helpers/handleFormChanges";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import PropTypes from "prop-types";

function LogosModal({ modalHook, valuesHook, salvaLogo }) {
  const { logoModal, setLogoModal } = modalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={"Nova logo"}
      is_open_modal={logoModal}
      set_is_open_modal={setLogoModal}
      size={"md"}
      buttons={
        <CommonButton onClick={salvaLogo} color="success" key={`upload-logo`}>
          Upload
        </CommonButton>
      }
    >
      <div className="row mb-3">
        <div className="col-md-6">
          <CommonInputFile
            label="Imagem"
            id="arquivo"
            onChange={(e) => {
              handleChangeFile(e, values, setValues);
            }}
            accept="image/*"
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

LogosModal.propTypes = {
  modalHook: PropTypes.shape({
    logoModal: PropTypes.bool.isRequired,
    setLogoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaLogo: PropTypes.func.isRequired,
};

export default LogosModal;
